import { useHistory, useLocation } from 'react-router';
import { Userpilot } from 'userpilot';
import { setQueryParam } from '../../../../common/src/hooks/query-params/useAddQueryParam';
import { useFlowsDispatch } from '../../../../common/src/utils/globalVariables';
import { setLastPosition } from '../../store/redux/slices/flowsMetaDataSlice';
import {
  setToastErrorMessage,
  setValidationErrorMessage,
} from '../../store/redux/slices/flowsSlice';
import store from '../../store/redux/store';
import { useFlowsRouteParams } from '../useFlowsRouteParams';

interface Response {
  previousQuestion: () => void;
}

const usePreviousQuestion = (): Response => {
  const flowsDispatch = useFlowsDispatch();
  const { position: positionString, flowId, sessionId } = useFlowsRouteParams();
  const position = Number(positionString);
  const history = useHistory();
  const { search } = useLocation();
  const previousQuestion = () => {
    const { metaData } = store.getState().flows;

    // Make sure user can always submit
    flowsDispatch(setToastErrorMessage(''));
    flowsDispatch(setValidationErrorMessage(''));

    // IF first question, push to inputRoute
    if (position !== 0) {
      // Push to previous route
      flowsDispatch(setLastPosition(position - 1));
      history.push(
        setQueryParam(
          `/flows/${flowId}/questions/${sessionId}/${position - 1}`,
          search,
        ),
      );
    } else if (metaData.inputUrl) {
      // Return to input url
      history.push(setQueryParam(metaData.inputUrl, search));
    }

    final();
  };

  /**
   * This function should be called when navigation is finished
   */
  const final = () => {
    Userpilot.reload();
  };

  return {
    previousQuestion,
  };
};

export default usePreviousQuestion;
